<template>
    <div class="ProfilePage">
        
        <v-container> <!-- Flex container for all-->

            <v-layout row wrap> <!-- Left & Right Layout yet again -->

                <v-flex xs12 md3> <!-- Left Side for User Profile, Name, & Change of picture -->

                    <v-layout justify-center align-center column> <!-- Layout to Organize -->

                        <v-flex xs12> <!-- User Profile Picture -->
                            <v-avatar size="100%">
                                <img class="ma-auto" :src="userProfilePicture" alt="User Picture">
                            </v-avatar>
                        </v-flex>

                        <v-flex xs12> <!-- UserName -->
                            <p class="display-1 text-xs-center py-2 my-0">{{username}}</p>
                        </v-flex>
                        
                        <v-flex xs12> <!-- User Email -->
                            <p class="subheading text-xs-center">{{email}}</p>
                        </v-flex>

                        <v-flex xs6 md2> <!-- Change profile picture here -->
                            <v-upload-button title="Change Picture" color="green lighten-3 white--text" depressed>

                            </v-upload-button>
                        </v-flex>

                        <v-flex xs12> <!-- Vertication Badges The User has obtained -->

                            <v-subheader>Badges</v-subheader>

                        </v-flex>

                    </v-layout>

                </v-flex>

                <v-flex xs0 md2></v-flex>

                <v-flex xs12 md7> <!-- Right side of the screen that includes: Previous Post, User Bio, and password change -->

                    <v-layout align-start column>

                        <v-flex xs12> <!-- Container that holds all the posted content -->

                            <v-list> <!-- List container that holds post -->

                                <v-subheader class="headline">Your Comments</v-subheader>
                                
                                <template v-for="posts in userPost">

                                    <v-card :key="posts.date" flat>

                                        <v-layout justify-center align-center wrap> <!-- Everything in the card is in a layout so stuff is aligned horizonally -->

                                            <v-flex xs1> <!-- User Profile Picture for cards -->
                                                <v-avatar size="45px" class="mx-auto" style="display:table;">
                                                    <img :src="userProfilePicture" alt="Profile Picture" />
                                                </v-avatar>
                                            </v-flex>

                                            <v-flex xs11> <!-- Flex where user message is stored -->

                                                <v-card-text> 
                                                    {{posts.message}}
                                                </v-card-text>

                                            </v-flex>

                                            <v-flex xs12> <!-- Date & Delete Option -->
                                                <v-layout align-end justify-end>
                                                    <v-flex xs2 md1>
                                                        <span @click="someFunction()" class="font-weight-bold red--text text--lighten-2">Delete</span>
                                                    </v-flex>

                                                    <v-flex xs2 md2>
                                                        <span class="font-weight-bold">{{posts.date}}</span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                        </v-layout>

                                    </v-card>
                                    
                                </template>

                            </v-list>

                        </v-flex>

                        <!-- <v-flex xs12>

                            <v-list>
                                <v-subheader>
                                    Bio
                                </v-subheader>

                                <v-text-area placeholder="Add a Bio Message Here...">
                                </v-text-area>
                            </v-list>

                        </v-flex > -->

                    </v-layout>

                </v-flex>

            </v-layout>

        </v-container>

    </div>
</template>

<script>
import {auth,database,storage} from '@/fb.js';
import UploadButton from 'vuetify-upload-button';
const storageReference = storage.ref();

export default {
    created() {
    },
    components: {
        'v-upload-button': UploadButton
    },
    data() {
        return {
            userProfilePicture: auth.currentUser.photoURL,
            username: auth.currentUser.displayName,
            email: auth.currentUser.email,
            userPost: [
                {message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sed iaculis dolor, blandit faucibus orci. Proin gravida nec nunc sed mattis. Donec a tempor libero. Sed vel turpis feugiat, suscipit sem nec, posuere orci. Integer eleifend urna sed quam mollis, quis maximus magna mollis. Integer finibus venenatis lectus sit amet rutrum. Morbi pharetra congue risus at dictum. Sed sit amet sapien lorem. Aliquam non condimentum enim. Nulla dapibus ultricies tempus. Donec laoreet sed sem vitae ullamcorper.',date: '19/04/20'},
                {message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sed iaculis dolor, blandit faucibus orci. Proin gravida nec nunc sed mattis. Donec a tempor libero. Sed vel turpis feugiat, suscipit sem nec, posuere orci. Integer eleifend urna sed quam mollis, quis maximus magna mollis. Integer finibus venenatis lectus sit amet rutrum. Morbi pharetra congue risus at dictum. Sed sit amet sapien lorem. Aliquam non condimentum enim. Nulla dapibus ultricies tempus. Donec laoreet sed sem vitae ullamcorper.',date: '19/05/20'},
            ]
        }
    },
    methods: {
        someFunction: function() {
            console.log('How do you feel?');
        },
        fileHander(file) {
            if(file.type === "image/png" || file.type === "image/jpeg") {
                console.log('OOGA BOOGA!');
                this.changeImage(file);
            } else {
                this.acualImage = null;
                this.curImage = '';
            }
        },
        changeImage(file) {
            console.log('updating user picture successful');
            let userCode = `userData/${auth.currentUser.uid}/userImage`;

                storageReference.child(userCode).put(file).then(() => { //updates the photo in storage
                    
                    storageReference.child(userCode).getDownloadURL().then(url => { //gets download url for photo and updates for users avatar

                        auth.currentUser.updateProfile({
                            photoURL: url
                        })
                    });
                })
        }
    }
}
</script>